import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export function useConversationScroll(messages, resetKey) {
  const scrollRef = useRef(null), contentRef = useRef(null);
  const following = useRef(true), previousUser = useRef(null);
  const [away, setAway] = useState(false);
  const jump = useCallback(() => {
    following.current = true; setAway(false);
    const node = scrollRef.current;
    if (node) node.scrollTop = node.scrollHeight;
  }, []);
  const onScroll = useCallback(() => {
    const node = scrollRef.current;
    if (!node) return;
    const near = node.scrollHeight - node.clientHeight - node.scrollTop <= 80;
    following.current = near; setAway(!near);
  }, []);
  useLayoutEffect(() => { previousUser.current = null; jump(); }, [resetKey, jump]);
  useLayoutEffect(() => {
    const user = messages.findLast(message => message.role === 'user')?.id;
    if (user !== previousUser.current) { previousUser.current = user; jump(); }
    else if (following.current) jump();
  }, [messages, jump]);
  useLayoutEffect(() => {
    // Resizing content or the input must not override the reader's choice.
    const observer = new ResizeObserver(() => { if (following.current) jump(); });
    if (scrollRef.current) observer.observe(scrollRef.current);
    if (contentRef.current) observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, [jump]);
  return { scrollRef, contentRef, onScroll, away, jump };
}
